import { makeStyles, createStyles, Button, Theme } from '@material-ui/core';
import React, { useContext, useMemo, useState, useEffect, FC } from 'react';
import json_pointer from 'json-pointer';

import { DismissibleDefinition } from '../services/layout';

import { FormContext, useVisibility, registry, FormControlProps } from '..';

var useStyles = makeStyles(function (theme: Theme) {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    wrapper: {
      borderBottomRightRadius: 0,
      borderRadius: theme.shape.borderRadius,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.palette.divider,
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
    },
    dismissButton: {
      marginTop: '-1px',
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
      alignSelf: 'flex-end',
      // marginTop: theme.spacing(-6),
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.divider,
    },
  });
});

export const Dismissible: FC<FormControlProps<DismissibleDefinition>> = function (props) {
  const form = useContext(FormContext).form;
  const definition = useMemo(function () {
    return json_pointer.get(form.definition, props.path);
  }, [props.path, form.id]);
  const [ isVisible, setIsVisible ] = useState(false);
  const explicitVisibility = useVisibility(props.path);
  useEffect(function watchVisibility() {
    if (explicitVisibility) {
      setIsVisible(explicitVisibility);
    }
  }, [explicitVisibility, isVisible]);
  const classes = useStyles(props);
  if (isVisible) {
    const Component = registry.getComponent(definition.child.type);

    if (!Component) {
      throw new Error('No such control ' + definition.child.type + ' exists');
    }

    return (
      <div className = { classes.root }>
        <div className =  { classes.wrapper }>
          <Component
            path = { props.path.concat('/child') }
            definition = { definition.child }>
          </Component>
          <Button
            className = { classes.dismissButton }
            color = { 'primary' }
            variant = { 'outlined' }
            disabled = { explicitVisibility }
            onClick = { () => setIsVisible(false) }>
              Dismiss
          </Button>
        </div>
      </div>
    )
  } else {
    return null;
  }
};

registry.registerComponent('Dismissible', Dismissible);
